<template>
	<h2 class="quote-card-title">
		<slot />
	</h2>
</template>

<script setup lang="ts"></script>

<style scoped>
.quote-card-title {
	font-size: 1.25rem;
	font-weight: 500;
	color: #000000;
	font-family: "Fira Sans", sans-serif;
}

@media (min-width: 1024px) {
	.quote-card-title {
		font-size: 1.875rem;
	}
}
</style>
